import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=ed31d482&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=ed31d482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed31d482",
  null
  
)

export default component.exports